import React, { useEffect, useState } from "react";

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
  loading?: "lazy" | "eager";
}

function LazyImage({
  src,
  alt,
  className = "",
  containerClassName = "",
  loading = "lazy",
}: LazyImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [src]);

  return (
    <div className={`relative ${containerClassName}`}>
      {!isLoaded && (
        <div className="image-skeleton absolute inset-0" aria-hidden="true" />
      )}
      <img
        src={src}
        alt={alt}
        loading={loading}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)}
        className={`transition-opacity duration-300 ${isLoaded ? "opacity-100" : "opacity-0"} ${className}`}
      />
    </div>
  );
}

export default LazyImage;
